import api from "api/api";
import { EmpresaModalData } from "./modal-empresa/types";
import { apiJWT } from "api/api-jwt";

export class EmpresasEndpoints {
  static async getEmpresas() {
    const response = await apiJWT.get("/customers");
    return response.data;
  }

  static async changeCashbackStatus(
    customerId: number,
    status: "ENABLED" | "DISABLED"
  ) {
    const response = await api.get(
      `/customers/${customerId}/change-cashback?status=${status}`
    );
    return response.data;
  }

  static async deleteEmpresa(customerId: number) {
    const response = await apiJWT.delete(`/customers/${customerId}`);
    return response.data;
  }

  static async getRegionais() {
    const response = await apiJWT.get("/customers/regionais");
    return response.data;
  }

  static async getComerciais() {
    const response = await api.get("/usuarios/comerciais");
    return response.data;
  }

  static async createEmpresa(payload: EmpresaModalData) {
    const response = await apiJWT.post("/customers", payload);
    return response.data;
  }

  static async updateEmpresa(customerId: number, payload: EmpresaModalData) {
    const response = await api.put(`/customers/${customerId}`, payload);
    return response.data;
  }

  static async getUsuariosByCustomer(
    customerId: number
  ): Promise<{ id: number; name: string }[]> {
    // TODO: endpoint a ser criado no backend
    const response = await api.get(`/customers/${customerId}/usuarios`);
    return response.data;
  }
}
